module.exports = __webpack_public_path__ + "img/pdv.6d45e08.png";